import React from 'react';
import { Scale, CheckCircle, Users, Globe2, Award } from 'lucide-react';
import { coreValues } from '../data/mock';

const iconMap = {
  Scale: Scale,
  CheckCircle: CheckCircle,
  Users: Users,
  Globe2: Globe2,
  Award: Award
};

export const ValuesSection = () => {
  return (
    <section id="values" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-[#0f3f5d] mb-4">
            Core Values That Guide Us
          </h2>
          <p className="text-xl text-gray-600">
            Our commitment to excellence is built on these fundamental principles
          </p>
        </div>

        {/* Values Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-5 gap-8">
          {coreValues.map((value, index) => {
            const IconComponent = iconMap[value.icon];
            
            return (
              <div 
                key={value.id}
                className="group relative"
              >
                {/* Card */}
                <div className="h-full bg-white rounded-xl p-6 shadow-lg hover:shadow-2xl transition-all duration-300 border-t-4 border-[#c2983e] hover:-translate-y-2">
                  {/* Icon */}
                  <div className="w-16 h-16 rounded-full bg-gradient-to-br from-[#508f9d] to-[#8b2e4a] flex items-center justify-center mb-4 group-hover:scale-110 transition-transform">
                    <IconComponent className="w-8 h-8 text-white" />
                  </div>
                  
                  {/* Title */}
                  <h3 className="text-xl font-bold text-[#0f3f5d] mb-3 group-hover:text-[#8b2e4a] transition-colors">
                    {value.title}
                  </h3>
                  
                  {/* Description */}
                  <p className="text-gray-700 text-sm leading-relaxed">
                    {value.description}
                  </p>
                </div>
              </div>
            );
          })}
        </div>

        {/* Bottom Banner */}
        <div className="mt-16 text-center">
          <div className="inline-block bg-[#508f9d]/5 rounded-2xl px-8 py-6 border border-[#508f9d]/20">
            <p className="text-lg text-[#0f3f5d] font-medium">
              <span className="text-[#8b2e4a] font-bold">Results-Driven.</span>{' '}
              <span className="text-[#508f9d] font-bold">Globally Connected.</span>{' '}
              <span className="text-[#c2983e] font-bold">Locally Expert.</span>
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};
